import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import './ListarMotoristas.css'
import api from '../../services/api'
import LoadingSpinner from '../../components/LoadingSpinner'
import SearchBar from '../../components/SearchBar'
import Pagination from '../../components/Pagination'
import EmptyState from '../../components/EmptyState'
import { FaEdit, FaTrash, FaTimes, FaSyncAlt } from 'react-icons/fa'

const EditarMotoristaModal = ({ motorista, onClose, onAtualizado }) => {
  const [formData, setFormData] = useState({
    name: motorista.name,
    cpf: motorista.cpf,
    phone: motorista.phone
  })
  const [loading, setLoading] = useState(false)

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)

    try {
      const token = localStorage.getItem('token')
      const user_name = localStorage.getItem('name')
      await api.put(`/api/driver/${motorista.uuid}/${user_name}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      toast.success('Motorista atualizado com sucesso!')
      onAtualizado()
      onClose()
    } catch (error) {
      console.error('Erro ao atualizar motorista:', error)
      toast.error(
        error.response?.data?.message || 'Erro ao atualizar motorista'
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='modal-overlay'>
      <div className='modal-content'>
        <div className='modal-header'>
          <h3>Editar Motorista</h3>
          <button onClick={onClose} className='modal-close-button'>
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className='driver-form'>
          <div className='form-group'>
            <label htmlFor='name'>Nome completo*</label>
            <input
              type='text'
              id='name'
              name='name'
              value={formData.name}
              onChange={handleChange}
              className='form-control'
              required
            />
          </div>

          <div className='form-group'>
            <label htmlFor='cpf'>CPF*</label>
            <input
              type='text'
              id='cpf'
              name='cpf'
              value={formData.cpf}
              onChange={handleChange}
              className='form-control'
              required
            />
          </div>

          <div className='form-group'>
            <label htmlFor='phone'>Telefone*</label>
            <input
              type='text'
              id='phone'
              name='phone'
              value={formData.phone}
              onChange={handleChange}
              className='form-control'
              required
            />
          </div>

          <div className='form-actions'>
            <button type='button' onClick={onClose} className='cancel-button'>
              Cancelar
            </button>
            <button type='submit' disabled={loading} className='submit-button'>
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

const ListarMotoristas = () => {
  const [motoristas, setMotoristas] = useState([])
  const [pagina, setPagina] = useState(1)
  const [totalPaginas, setTotalPaginas] = useState(1)
  const [totalItems, setTotalItems] = useState(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [filtroAtivo, setFiltroAtivo] = useState(false)
  const [modalAberto, setModalAberto] = useState(false)
  const [motoristaSelecionado, setMotoristaSelecionado] = useState(null)
  const navigate = useNavigate()

  const fetchDrivers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
            return;
        }

        // Endpoint atualizado para corresponder ao backend
        const endpoint = searchTerm
            ? `/api/front/drivers/search?query=${encodeURIComponent(searchTerm)}&page=${pagina}`
            : `/api/front/drivers?page=${pagina}`;

        const response = await api.get(endpoint, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        setMotoristas(response.data.data || []);
        setTotalPaginas(response.data.totalPages || 1);
        setTotalItems(response.data.totalRecords || 0); // Mudei de totalItems para totalRecords

        setFiltroAtivo(!!searchTerm);
    } catch (error) {
        console.error('Erro ao buscar motoristas:', error);
        setError('Erro ao carregar motoristas. Tente novamente mais tarde.');
        toast.error('Erro ao carregar motoristas');
    } finally {
        setLoading(false);
    }
}, [pagina, searchTerm, navigate]);

  useEffect(() => {
    fetchDrivers()
  }, [fetchDrivers])

  const handleDeleteDriver = async (driverId) => {
    if (window.confirm('Tem certeza que deseja excluir este motorista?')) {
      try {
        const token = localStorage.getItem('token');
        const userName = localStorage.getItem('name'); // Certifique-se que está salvo
        
        const response = await api.delete(
          `/api/front/driver/${driverId}/${userName}`, // Note a adição do userName na URL
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );
  
        toast.success(response.data.message || 'Motorista excluído com sucesso!');
        fetchDrivers(); // Atualiza a lista
      } catch (error) {
        console.error('Detalhes do erro:', error.response);
        toast.error(error.response?.data?.error || 'Erro ao excluir motorista');
      }
    }
  };

  const handleSearch = term => {
    setSearchTerm(term)
    setPagina(1)
  }

  const handleClearSearch = () => {
    setSearchTerm('')
    setPagina(1)
  }

  const handlePaginaAnterior = () => {
    if (pagina > 1) setPagina(pagina - 1)
  }

  const handleProximaPagina = () => {
    if (pagina < totalPaginas) setPagina(pagina + 1)
  }

  const handleAbrirModalEdicao = motorista => {
    setMotoristaSelecionado(motorista)
    setModalAberto(true)
  }

  const handleFecharModal = () => {
    setModalAberto(false)
  }

  const handleAtualizacaoConcluida = () => {
    fetchDrivers()
  }

  const handleAtualizarLista = () => {
    fetchDrivers()
  }

  return (
    <div className='listar-motoristas-container'>
      <div className='container-drivers'>
        <div className='header-section'>
          <h2>Motoristas cadastrados</h2>
          <div className='controls'>
          <SearchBar
              onSearch={handleSearch}
              onClear={handleClearSearch}
              placeholder='Buscar por Nome...'
            />
            <button
              className='refresh-button'
              onClick={handleAtualizarLista}
              disabled={loading}
              title='Atualizar lista'
            >
              <FaSyncAlt />
            </button>
          </div>
        </div>

        {error && <div className='error-message'>{error}</div>}

        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className='summary-info'>
              <span>Total: {totalItems} motoristas</span>
              {filtroAtivo && (
                <span className='filter-active'>
                  Filtro ativo - {motoristas.length} resultados
                  <button onClick={handleClearSearch} className='clear-filter'>
                    Limpar filtro
                  </button>
                </span>
              )}
            </div>

            {motoristas.length === 0 ? (
              <EmptyState
                message={
                  searchTerm
                    ? 'Nenhum motorista encontrado com esse critério'
                    : 'Nenhum motorista cadastrado ainda'
                }
              />
            ) : (
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>CPF</th>
                      <th>Telefone</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {motoristas.map(motorista => (
                      <tr key={motorista.uuid}>
                        <td>{motorista.name}</td>
                        <td>{motorista.cpf}</td>
                        <td>{motorista.phone}</td>
                        <td className='actions-cell'>
                          <button
                            className='edit-button'
                            onClick={() => handleAbrirModalEdicao(motorista)}
                            title='Editar'
                          >
                            <FaEdit />
                          </button>
                          <button
                            className='delete-button'
                            onClick={() => handleDeleteDriver(motorista.uuid)}
                            title='Excluir'
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {totalPaginas > 1 && (
              <Pagination
                currentPage={pagina}
                totalPages={totalPaginas}
                onPreviousPage={handlePaginaAnterior}
                onNextPage={handleProximaPagina}
                onPageChange={page => setPagina(page)}
              />
            )}
          </>
        )}
      </div>

      {modalAberto && (
        <EditarMotoristaModal
          motorista={motoristaSelecionado}
          onClose={handleFecharModal}
          onAtualizado={handleAtualizacaoConcluida}
        />
      )}
    </div>
  )
}

export default ListarMotoristas